import { render, staticRenderFns } from "./BrandTrialEnd.vue?vue&type=template&id=71e06d64&scoped=true&lang=pug"
import script from "./BrandTrialEnd.vue?vue&type=script&lang=js"
export * from "./BrandTrialEnd.vue?vue&type=script&lang=js"
import style0 from "./BrandTrialEnd.vue?vue&type=style&index=0&id=71e06d64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e06d64",
  null
  
)

export default component.exports